<template>
  <hic-dialog append-to-body :close-on-click-modal="false" :visible="visible" width="65rem" @open="open" :title="'员工编辑'" @close="cancel">
    <el-form :inline="true" :model="staff" :rules="comRules" ref="editor" label-width="5rem" label-position="right">
      <el-row>
        <el-col :span="8" class="center">
          <hic-img-uploader v-model="staff.avatar" img-style="width:120px;height:120px;" tip="头像：小于2MB的 JPG 或 PNG !" />
        </el-col>
        <el-col :span="8">
          <el-form-item label="登录名" prop="account" size="small">
            <el-input type="text" placeholder="请输入登录名" v-model.trim="staff.account" :disabled="staff.id !== null" auto-complete="new-account" />
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item label="姓名" prop="name" size="small">
            <el-input type="text" placeholder="请输入姓名" v-model.trim="staff.name"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item label="性别" prop="gener" size="small">
            <hic-dict-selector dict-type="Gender" v-model="staff.gender" style="width: 93%" />
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item label="类型" prop="type" size="small">
            <hic-dict-selector dict-type="StaffType" v-model="staff.type" style="width: 93%" />
          </el-form-item>
        </el-col>

        <el-col :span="8">
          <el-form-item label="手机" prop="phone" size="small">
            <el-input type="text" placeholder="请输入手机号码" v-model="staff.phone" />
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item label="邮箱" prop="email" size="small">
            <el-input type="text" placeholder="请输入邮件地址" v-model="staff.email" />
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item label="科室" prop="deptCodesSelected" size="small">
            <el-select v-model="staff.deptCodesSelected" clearable multiple filterable :filter-method="deptFilter" placeholder="请选择" style="width: 93%">
              <el-option v-for="item in depts" :key="item.code" :label="item.name" :value="item.code">
                <span v-if="item.grade == 1">{{ item.name }}</span>
                <span v-if="item.grade == 2">- {{ item.name }}</span>
                <span v-if="item.grade == 3">- - {{ item.name }}</span>
              </el-option>
            </el-select>
          </el-form-item>
        </el-col>

        <el-col v-if="isDoctor" :span="8">
          <el-form-item label="医生职级" prop="position" size="small">
            <hic-dict-selector dict-type="DoctorPosition" v-model="staff.position" style="width: 93%" />
          </el-form-item>
        </el-col>
        <el-col v-if="isDoctor" :span="8">
          <el-form-item label="药品专控" prop="drugRestrict" size="small">
            <el-select v-model="staff.drugRestrictSelected" clearable multiple filterable placeholder="请选择" style="width: 93%" size="small">
              <el-option v-for="item in dict.DrugRestrict" :key="item.code" :label="item.text" :value="item.code"></el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col v-if="isDoctor" :span="8">
          <el-form-item label="是否专家" prop="ifExpert" size="small">
            <el-switch v-model="staff.ifExpert"></el-switch>
            <span class="left-pad">远程会诊</span>
            <el-switch v-model="staff.needOnline" class="left-pad"></el-switch>
          </el-form-item>
        </el-col>

        <el-col :span="8">
          <el-form-item label="身份证件" prop="idType" size="small">
            <hic-dict-selector dict-type="IdType" v-model="staff.idType" style="width: 93%" />
          </el-form-item>
        </el-col>

        <el-col :span="8">
          <el-form-item label="证件号" prop="idNo" size="small">
            <el-input type="text" placeholder="请输入证件号" v-model="staff.idNo"></el-input>
          </el-form-item>
        </el-col>

        <el-col :span="8">
          <el-form-item label="资格证件" prop="certificateType" size="small">
            <el-select v-model="staff.certificateType" clearable placeholder="请选择" style="width: 93%">
              <el-option v-for="item in certificateTypeList" :key="item.code" :label="item.text" :value="item.code"></el-option>
            </el-select>
          </el-form-item>
        </el-col>

        <el-col :span="8">
          <el-form-item label="资格证号" prop="certificateNo" size="small">
            <el-input type="text" placeholder="请输入资格证号" v-model="staff.certificateNo"></el-input>
          </el-form-item>
        </el-col>

        <el-col :span="8">
          <el-form-item label="职称" prop="title" size="small">
            <hic-dict-selector dict-type="TitleType" v-model="staff.title" style="width: 93%" />
          </el-form-item>
        </el-col>

        <el-col :span="8">
          <el-form-item label="执业地点" prop="orgName" size="small">
            <hic-dict-selector dict-type="StaffOrg" v-model="staff.orgName" style="width: 93%" />
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item label="邮编" prop="zipCode" size="small">
            <el-input type="text" placeholder="请输入邮编" v-model="staff.zipCode"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item label="用户锁定" prop="" size="small">
            <!-- <el-switch v-model="staff.locked" active-text="是" inactive-text="否"></el-switch> -->
            <el-date-picker :default-time="$utils.Dt.time()" type="datetime" placeholder="选择日期" value-format="timestamp" :picker-options="pickerOptions" v-model="staff.locked" style="width: 88%"></el-date-picker>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item label="住址" prop="address" size="small">
            <el-input type="textarea" :rows="2" placeholder="请输入地址" v-model="staff.address" style="width: 107%"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item label="简介" prop="resume" size="small">
            <el-input type="textarea" :rows="2" placeholder="请输入简介" v-model="staff.resume" style="width: 107%"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-popover v-if="!defaultImgLoading && staff.id && isDoctor" placement="top" title="手写签名" trigger="click" v-model="defaultImgShow">
            <el-row class="center">
              <hic-img-uploader v-model="defaultImg" imgStyle="height: 2rem" tip="小于2MB的 JPG 或 PNG !" @loaded="defaultImgChange" @unloaded="defaultImgChange" />
            </el-row>

            <el-button slot="reference" type="text">
              <el-image v-if="defaultImg" style="height: 2rem" :src="defaultImg" />
              <span v-else>手写签名</span>
            </el-button>
          </el-popover>
        </el-col>
      </el-row>
    </el-form>
    <div slot="footer" class="dialog-footer">
      <el-button v-if="staff.id" type="warning" @click="toSynchronizeInfo" :disabled="synDisabledSave">同步北京CA</el-button>
      <el-button v-if="staff.id" type="danger" @click="resetPwd">重置密码</el-button>
      <el-button type="info" @click="cancel">关 闭</el-button>
      <el-button type="primary" @click="save" :disabled="disabledSave">确 定</el-button>
    </div>
  </hic-dialog>
</template>

<script>
  import api from "./api";
  import { mapGetters } from "sw-hic";
  export default {
    props: {
      visible: Boolean,
      staff: Object,
    },
    data() {
      var validateCode = (rule, value, callback) => {
        if (!/^[0-9a-zA-Z_-]*$/.test(value)) {
          return callback(new Error("登录名只能包含：【大小写字母】【数字】【_】【-】"));
        }
        return callback();
      };
      var validateTelephone = (rule, value, callback) => {
        if (value && !/^[0-9]*$/.test(value)) {
          return callback(new Error("电话只能包含：【数字】"));
        }
        return callback();
      };

      return {
        defaultImg: null,
        defaultImgShow: false,
        defaultImgLoading: false,
        pickerOptions: {
          // 限制收货时间不让选择今天以前的
          disabledDate(time) {
            return time.getTime() < Date.now() - 8.64e7;
          },
        },

        value1: null,
        comRules: {
          account: [
            {
              required: true,
              message: "请输入用户名",
              trigger: "blur",
            },
            {
              max: 20,
              message: "编码长度在 20 个字符以内",
              trigger: "blur",
            },
            {
              validator: validateCode,
              trigger: "blur",
            },
          ],
          type: [
            {
              required: true,
              message: "请选择类型",
              trigger: "blur",
            },
          ],
          name: [
            {
              required: true,
              message: "请输入姓名",
              trigger: "blur",
            },
            {
              max: 20,
              message: "名称长度在 20 个字符以内",
              trigger: "blur",
            },
          ],
          phone: [
            {
              max: 32,
              message: "电话长度在 32 个字符以内",
              trigger: "blur",
            },
            {
              validator: validateTelephone,
              trigger: "blur",
            },
          ],
          address: [
            {
              max: 128,
              message: "地址长度在 128 个字符以内",
              trigger: "blur",
            },
          ],
          deptCodesSelected: [
            {
              required: true,
              message: "请选择科室",
              trigger: "blur",
            },
          ],
        },
        disabledSave: false,
        synDisabledSave: false,
        deptFilterKey: null,
        certificateTypeList: [
          {
            code: "YS",
            text: "医师资格证",
          },
          {
            code: "YJ",
            text: "药剂师资格证",
          },
          {
            code: "YY",
            text: "营养师资格证",
          },
          {
            code: "ZC",
            text: "助产师证",
          },
          {
            code: "XL",
            text: "心理咨询师证",
          },
          {
            code: "YL",
            text: "医疗技师证",
          },
          {
            code: "HS",
            text: "护士资格证",
          },
          {
            code: "QT",
            text: "其它",
          },
        ],
      };
    },
    computed: {
      ...mapGetters(["dict", "user"]),
      depts() {
        let items = [];
        items.push(...this.dict.Dept.filter((d) => !this.deptFilterKey || (d.text + d.code + d.shortCode).includes(this.deptFilterKey)));
        items.sort((a, b) => {
          return `${a.codeChain}${a.code}` > `${b.codeChain}${b.code}`;
        });
        return items;
      },
      isDoctor() {
        return this.staff.type == "0";
      },
    },
    created() {
      this.open();
    },
    methods: {
      open() {
        this.defaultImg = null;
        this.defaultImgShow = false;
        if (this.staff && this.staff.id) {
          this.queryOidc(this.staff.id);
          this.defaultImgLoading = true;
          api.Staff.getOidcImg({ auCode: "hic", openId: this.staff.id })
            .then((res) => {
              this.defaultImg = res;
            })
            .catch((err) => {
              console.log(err);
            })
            .finally(() => {
              this.defaultImgLoading = false;
            });
          try {
            this.$set(this.staff, "deptCodesSelected", JSON.parse(this.staff.deptCodes));
          } catch (error) {
            this.$set(this.staff, "deptCodesSelected", []);
          }
          if (this.staff.drugRestrict) {
            this.$set(
              this.staff,
              "drugRestrictSelected",
              JSON.parse(this.staff.drugRestrict).map((m) => m.code)
            );
          } else {
            this.$set(this.staff, "drugRestrictSelected", []);
          }
        }
      },
      queryOidc(staffId) {
        api.Staff.queryOidc(staffId).then((res) => {
          if (res.items.length != 0) {
            if (res.items.find((i) => (i.auCode = "bjcaQr"))) {
              this.synDisabledSave = true;
              return;
            }
          }
          this.synDisabledSave = false;
        });
      },
      toSynchronizeInfo() {
        let _this = this;
        _this.loading = true;
        api.Staff.sync(_this.staff.id, "au")
          .then((res) => {
            this.$utils.log(res);
            if (res.status == 0) {
              this.$message({
                message: res.message,
                type: "success",
              });
            } else if (res.status == 1) {
              this.$message({
                message: res.message,
                type: "warning",
              });
            } else {
              this.$message.error(res.message);
            }

            // this.$emit("update:visible", false);
          })
          .catch((err) => {
            console.log(err);
          })
          .finally(() => {
            _this.loading = false;
          });
      },
      cancel() {
        this.$emit("update:visible", false);
        this.$emit("cancel");
      },
      deptFilter(key) {
        this.deptFilterKey = key;
        this.$utils.log(key);
      },
      resetPwd() {
        this.$prompt("员工密码将被设置为系统默认密码，需要输入您的密码验证是当前登录者本人在操作。", "重置密码", {
          inputPlaceholder: "请输入您的密码",
          inputType: "password",
          inputValidator: (value) => {
            if (!value) {
              return "密码不能为空";
            }
          },
        })
          .then(({ value }) => {
            api.Staff.pwd({
              staffId: this.staff.id,
              userPassword: value,
            })
              .then(() => {
                this.$message.success("修改成功！");
              })
              .catch((err) => {
                this.$message.error(`修改失败！${err}`);
              });
          })
          .catch((err) => {
            console.log(err);
          });
      },
      save() {
        let _this = this;
        this.$utils.log("staff", this.staff);
        this.$refs.editor
          .validate()
          .then((valid) => {
            _this.disabledSave = true;
            if (_this.staff.deptCodesSelected.length) {
              _this.staff.deptCode = _this.staff.deptCodesSelected[0];
              _this.staff.deptCodes = JSON.stringify(_this.staff.deptCodesSelected);
            } else {
              _this.staff.deptCode = null;
              _this.staff.deptCodes = null;
              return;
            }
            if (_this.staff.type != "0") {
              _this.staff.position = null;
              _this.staff.ifExpert = false;
              _this.staff.drugRestrict = null;
            } else {
              if (_this.staff.drugRestrictSelected && _this.staff.drugRestrictSelected.length) {
                let restricts = _this.staff.drugRestrictSelected.reduce((prev, cur) => {
                  let item = _this.dict.DrugRestrict.find((f) => f.code == cur);
                  if (item) {
                    prev.push({
                      code: item.code,
                      text: item.text,
                    });
                  }
                  return prev;
                }, []);
                _this.staff.drugRestrict = JSON.stringify(restricts);
              } else {
                _this.staff.drugRestrict = null;
              }
            }
            return api.Staff.save(_this.staff);
          })
          .then((newEntity) => {
            _this.disabledSave = false;
            this.$emit("update:visible", false);
            this.$emit("ok", newEntity);
            _this.$message.success("保存成功！");
          })
          .catch((err) => {
            _this.disabledSave = false;
            if (err) {
              _this.$message.error(err.message || err);
            }
          });
      },
      defaultImgChange() {
        this.defaultImgShow = false;
        api.Staff.updateOidc({
          auCode: "hic",
          openId: this.staff.id,
          signImage: this.defaultImg,
        }).catch((err) => {
          api.Staff.addOidc(this.staff.id, {
            auCode: "hic",
            openId: this.staff.id,
            signImage: this.defaultImg,
            staffId: this.staff.id,
          }).catch((err) => {
            this.defaultImg = null;
            this.$message.error(err);
          });
        });
      },
    },
  };
</script>
